import {
  querySerializer as getExperimentQuerySerializer,
  type GetExperimentsQueryParams,
} from './getExperimentsOverrides';

export interface GetExperimentsAnyEnvQueryParams extends GetExperimentsQueryParams {}

export function querySerializer(queryParams: GetExperimentsAnyEnvQueryParams) {
  return getExperimentQuerySerializer(queryParams);
}
